import React, { FC } from 'react';

import PropTypes from 'prop-types';

import { StylableComponent, stylePropType } from '@adsk/alloy-react-helpers';
import Illustration from '@adsk/alloy-react-illustration';
import theme from '@adsk/alloy-react-theme';

type TopBarProps = StylableComponent<HTMLDivElement> & {
  hideLogo?: boolean;
  admin?: boolean;
};

const TopBar: FC<TopBarProps> = ({
  className,
  style,
  children,
  hideLogo,
  admin,
}) => (
  <div
    className={className}
    css={[
      {
        display: 'flex',
        alignItems: 'center',
        padding: '2px 10px',
        height: 18,
        background: admin ? theme.colors.charcoal700 : theme.colors.black,
      },
      style,
    ]}
  >
    <Illustration
      style={{ ...(hideLogo && { visibility: 'hidden' }) }}
      type={Illustration.TYPES.ACC_HORIZONTAL_WHITE_NEW_2022}
    />

    {children}
  </div>
);

TopBar.displayName = 'TopBar';

TopBar.propTypes = {
  /** TopBar's children */
  children: PropTypes.node,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** whether current view is external (login or public) */
  hideLogo: PropTypes.bool,
  /** whether current view is admin */
  admin: PropTypes.bool,
};

export default TopBar;
